import { useMemo } from "react";

export const useConst = <T>(fn: () => T) => {
    return useMemo(fn, []); //eslint-disable-line
};
